import { render, staticRenderFns } from "./FormColor.vue?vue&type=template&id=6495951f&scoped=true"
import script from "./FormColor.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormColor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FormColor.vue?vue&type=style&index=0&id=6495951f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6495951f",
  null
  
)

export default component.exports